@if (!!data) {
  <div class="dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{data.title | translate}}</span>
      <button class="close-ref" mat-icon-button [title]="'general.close' | translate | titlecase" (click)="close()">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div class="payment-content" mat-dialog-content>
      <!-- Explanation text -->
      <p class="explanation-text" [innerHTML]="'shop.buy_message' | translate : { watermark: 'zonder watermerk'}"></p>
      <!-- Image/video -->
      <div class="preview-block">
        <div class="price-container">
          <p class="price-display">€ {{data.price}} + € 2 {{"shop.service_costs" | translate}}</p>
        </div>
        @if (data.imageUrl) {
          <img [src]="data.imageUrl" alt="Image" class="dialog-image">
        }
        <img class="creator-age-indicator" [src]="`assets/images/Shield_${isCreatorUnderage ? '18-' : '18+'}.png`" alt="user-age-image" />
      </div>
      @if(isCreatorUnderage) {
        <span class="age-warning">{{ "shop.age_warning" | translate }}</span>
      }
      <span class="terms">
        Onze
        <a href="../../../assets/static/Streapp_Algemene_Voorwaarden_v1.1.pdf" target="_blank">algemene voorwaarden</a>
        zijn van toepassing.
      </span>
    </div>
    @if (data.showButton) {
      <div mat-dialog-actions class="dialog-buttons">
        @if (data.showCancelButton) {
          <button class="close-ref" mat-flat-button [color]="'primary'" [title]="'general.cancel' | translate" (click)="close()">
            {{ 'general.cancel' | translate }}
          </button>
        }
        <button class="close-ref buy-confirm" mat-flat-button [title]="data.buttonText | translate" (click)="closeWithConfirm()">
          {{ data.buttonText | translate }}
        </button>
      </div>
    }
  </div>
}

